import { render, staticRenderFns } from "./departmentTree.vue?vue&type=template&id=43b6e0cc&scoped=true"
import script from "./departmentTree.vue?vue&type=script&lang=js"
export * from "./departmentTree.vue?vue&type=script&lang=js"
import style0 from "./departmentTree.vue?vue&type=style&index=0&id=43b6e0cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b6e0cc",
  null
  
)

export default component.exports